"use client";

import { useContext } from "react";
import { MixpanelContext } from "@/providers/mixpanel-provider/mixpanel-provider";
import mixpanel from "mixpanel-browser";

export const useMixpanel = () => {
  const context = useContext(MixpanelContext);

  const track = (eventName: string, properties?: object) => {
    if (process.env.NODE_ENV !== "production") return;
    if (!mixpanel.__loaded) return;

    mixpanel.track(eventName, {
      ...properties,
      environment: process.env.NODE_ENV,
      timestamp: new Date().toISOString(),
    });
  };

  const identifyUser = (userId: string, userProps?: object) => {
    if (process.env.NODE_ENV !== "production") return;
    mixpanel.identify(userId);
    if (userProps) {
      mixpanel.people.set(userProps);
    }
  };

  return {
    track,
    identifyUser,
    ...context,
  };
};
